import {packNormal} from "../utils/fixNormals";

import {avp, THREE} from "@adsk/lmv";

export let dummyMaterial = new THREE.MeshBasicMaterial({color: 0xffffff});

let unitBox;
let unitBoxPackedNormals;

export function getUnitBox() {

	if (unitBox) {
		return unitBox;
	}

	const bb = new THREE.Box3();
	bb.min.x = 0;
	bb.min.y = 0;
	bb.min.z = 0;
	bb.max.x = 1;
	bb.max.y = 1;
	bb.max.z = 1;

	let mdata = {
		mesh: {
			vb: new Float32Array([
				//front (y = 0) 0-3
				0,0,0, 0,-1,0,
				1,0,0, 0,-1,0,
				1,0,1, 0,-1,0,
				0,0,1, 0,-1,0,

				//left (x = 0) 4-7
				0,0,0, -1,0,0,
				0,0,1, -1,0,0,
				0,1,1, -1,0,0,
				0,1,0, -1,0,0,

				//right (x = 1) 8-11
				1,0,0, 1,0,0,
				1,1,0, 1,0,0,
				1,1,1, 1,0,0,
				1,0,1, 1,0,0,

				//top (z = 1) 12-15
				0,0,1, 0,0,1,
				1,0,1, 0,0,1,
				1,1,1, 0,0,1,
				0,1,1, 0,0,1,

				//bottom (z = 0) 16-19
				0,0,0, 0,0,-1,
				0,1,0, 0,0,-1,
				1,1,0, 0,0,-1,
				1,0,0, 0,0,-1,

				//back (y = 1) 20-23
				0,1,0, 0,1,0,
				0,1,1, 0,1,0,
				1,1,1, 0,1,0,
				1,1,0, 0,1,0,
				]
			),
			indices: new Uint16Array([
				0,1,2,0,2,3, //front
				4,5,6,4,6,7, //left
				8,9,10,8,10,11, //right
				12,13,14,12,14,15, //top
				16,17,18,16,18,19, //bottom
				20,21,22,20,22,23]), //back
			iblines: new Uint16Array([0,1,1,2,2,3,3,0, 20,21,21,22,22,23,23,20, 0,20,1,23,2,22,3,21]),

			vbstride: 6,
			vblayout : {
				position : { offset: 0, itemSize: 3, bytesPerItem: 4},
				normal: { offset: 3, itemSize: 3, bytesPerItem: 4 },
			},
			boundingBox: bb,
			boundingSphere: { center: new THREE.Vector3(0.5,0.5,0.5),
							  radius: Math.sqrt(3) * 0.5 }
		}
	};

	unitBox = avp.BufferGeometryUtils.meshToGeometry(mdata);

	return unitBox;
}

export function getUnitBoxPackedNormals() {
	if (unitBoxPackedNormals) {
		return unitBoxPackedNormals;
	}

	const bb = new THREE.Box3();
	bb.min.x = 0;
	bb.min.y = 0;
	bb.min.z = 0;
	bb.max.x = 1;
	bb.max.y = 1;
	bb.max.z = 1;

	let mdata = {
		mesh: {
			vb: new Float32Array([
				//front (y = 0) 0-3
				0,0,0, 0,
				1,0,0, 0,
				1,0,1, 0,
				0,0,1, 0,

				//left (x = 0) 4-7
				0,0,0, 0,
				0,0,1, 0,
				0,1,1, 0,
				0,1,0, 0,

				//right (x = 1) 8-11
				1,0,0, 0,
				1,1,0, 0,
				1,1,1, 0,
				1,0,1, 0,

				//top (z = 1) 12-15
				0,0,1, 0,
				1,0,1, 0,
				1,1,1, 0,
				0,1,1, 0,

				//bottom (z = 0) 16-19
				0,0,0, 0,
				0,1,0, 0,
				1,1,0, 0,
				1,0,0, 0,

				//back (y = 1) 20-23
				0,1,0, 0,
				0,1,1, 0,
				1,1,1, 0,
				1,1,0, 0,
				]
			),
			indices: new Uint16Array([
				0,1,2,0,2,3, //front
				4,5,6,4,6,7, //left
				8,9,10,8,10,11, //right
				12,13,14,12,14,15, //top
				16,17,18,16,18,19, //bottom
				20,21,22,20,22,23]), //back
			iblines: new Uint16Array([0,1,1,2,2,3,3,0, 20,21,21,22,22,23,23,20, 0,20,1,23,2,22,3,21]),

			vbstride: 4,
			vblayout : {
				position : { offset: 0, itemSize: 3, bytesPerItem: 4},
				normal: { offset: 3, itemSize: 2, bytesPerItem: 2 },
			},
			boundingBox: bb,
			boundingSphere: { center: new THREE.Vector3(0.5,0.5,0.5),
							  radius: Math.sqrt(3) * 0.5 }
		}
	};

	let vbi = new Uint16Array(mdata.mesh.vb.buffer);
	packNormal(vbi, 3*2, 0,-1,0);
	packNormal(vbi, 7*2, 0,-1,0);
	packNormal(vbi, 11*2, 0,-1,0);
	packNormal(vbi, 15*2, 0,-1,0);

	packNormal(vbi, 19*2, -1,0,0);
	packNormal(vbi, 23*2, -1,0,0);
	packNormal(vbi, 27*2, -1,0,0);
	packNormal(vbi, 31*2, -1,0,0);

	packNormal(vbi, 35*2, 1,0,0);
	packNormal(vbi, 39*2, 1,0,0);
	packNormal(vbi, 43*2, 1,0,0);
	packNormal(vbi, 47*2, 1,0,0);

	packNormal(vbi, 51*2, 0,0,1);
	packNormal(vbi, 55*2, 0,0,1);
	packNormal(vbi, 59*2, 0,0,1);
	packNormal(vbi, 63*2, 0,0,1);

	packNormal(vbi, 67*2, 0,0,-1);
	packNormal(vbi, 71*2, 0,0,-1);
	packNormal(vbi, 75*2, 0,0,-1);
	packNormal(vbi, 79*2, 0,0,-1);

	packNormal(vbi, 83*2, 0,1,0);
	packNormal(vbi, 87*2, 0,1,0);
	packNormal(vbi, 91*2, 0,1,0);
	packNormal(vbi, 95*2, 0,1,0);

	unitBoxPackedNormals = avp.BufferGeometryUtils.meshToGeometry(mdata);

	return unitBoxPackedNormals;

}

export function getBoxMesh(box, material, packNormals) {

	const mesh = new THREE.Mesh(packNormals ? getUnitBoxPackedNormals() : getUnitBox(), material || dummyMaterial);
	const m = mesh.matrix.elements;
	const mw = mesh.matrixWorld.elements;

	const w = box.max.x - box.min.x;
	const h = box.max.y - box.min.y;
	const d = box.max.z - box.min.z;
	m[0] = mw[0] = w;
	m[5] = mw[5] = h;
	m[10] = mw[10] = d;
	m[12] = box.min.x;
	m[13] = box.min.y;
	m[14] = box.min.z;

	mesh.matrixAutoUpdate = false;
	mesh.matrixWorldNeedsUpdate = false;

	return mesh;
}
